import { Component, OnInit, ViewChild } from '@angular/core';
import { WidgetHostService } from 'app/shared/widget/widget-host-service';
import { WidgetReportItem } from 'app/shared/widget/widget-item';
import { WidgetHostDirective } from 'app/shared/widget/widget-host.directive';
import { ProfileBasedOffersComponent } from "app/calculators/home-loan-comparison-calculator/profile-based-offers/profile-based-offers.component";
import { GroupOffersComponent } from "app/calculators/home-loan-comparison-calculator/group-offers/group-offers.component";
import { PropertyBasedOffersComponent } from "app/calculators/home-loan-comparison-calculator/property-based-offers/property-based-offers.component";
import { ChatToGetOffersComponent } from "app/calculators/home-loan-comparison-calculator/chat-to-get-offers/chat-to-get-offers.component";
import { BalanceTransferOffersComponent } from "app/calculators/home-loan-comparison-calculator/balance-transfer-offers/balance-transfer-offers.component";
import { Router, ActivatedRoute } from '@angular/router';
import { Http, RequestOptions } from '@angular/http';
import * as emiGlobals from 'app/globals';
import { HttpService } from "app/shared/services/http.service";
import { QuestionsComponent } from "app/calculators/home-loan-comparison-calculator/questions/questions.component";
import { CalculatorService } from "app/calculators/calculator.service";


@Component({
  selector: 'app-calculator-left-side-menu',
  templateUrl: './calculator-left-side-menu.component.html',
  styleUrls: ['./calculator-left-side-menu.component.css']
})
export class CalculatorLeftSideMenuComponent implements OnInit {

  // activeTab: string;
  // @ViewChild('bank', { read: WidgetHostDirective }) bank;
  // headers: any;
  // private options: RequestOptions;
  // productList: any;
  // dataList: any;
  // questionType: any;
  // categoryList: any;

  constructor(public widgetHostService: WidgetHostService, public router: Router,
    public route: ActivatedRoute, private http: Http, private httpService: HttpService,
    public calculatorService: CalculatorService
  ) {
  }

  ngOnInit() {
    // this.calculatorService.currentValues.subscribe(data => {
    //   console.log('----data----' , data);
    // });
    // let postItems: any = [];
    // postItems = this.getAllPosts();
    // this.route.queryParams.subscribe(data => {
    //   const id = data['0'];
    //   if (id !== undefined) {
    //     this.widgetHostService.loadReportComponent(this.bank.viewContainerRef, postItems[id - 1]);
    //   } else {
    //     this.widgetHostService.loadReportComponent(this.bank.viewContainerRef, postItems[0]);
    //   }
    // });
    // this.calculatorService.getAllProductCategory();

    // this.widgetHostService.loadReportComponent(this.bank.viewContainerRef, postItems[tabId - 1]);
  }
 

  // onTabClick(tabId: any) {
  //   this.router.navigate(['/calculator/bank-comparison'], {
  //     queryParams: tabId
  //   });
  //   let postItems: any = [];
  //   postItems = this.getAllPosts();
  //   this.widgetHostService.loadReportComponent(this.bank.viewContainerRef, postItems[tabId - 1]);

  // }

  // private getAllPosts() {
  //   return [
  //     new WidgetReportItem(BankComparisonComponent, {
  //     }),
  //     new WidgetReportItem(BalanceTransferOffersComponent, {}),
  //     new WidgetReportItem(ProfileBasedOffersComponent, {}),
  //     new WidgetReportItem(GroupOffersComponent, {}),
  //     new WidgetReportItem(PropertyBasedOffersComponent, {}),
  //     new WidgetReportItem(ChatToGetOffersComponent, {}),
  //     new WidgetReportItem(CallToGetOffersComponent, {})
  //   ];

  // }

  // private getQuestions(productId: any, questionType: any, bankId: any) {
  //   return [
  //     new WidgetReportItem(QuestionsComponent, {
  //       configData: this.dataList, productId: productId, questionType: questionType, bankId: bankId
  //     }),
  //   ];
  // }

  // getBasicLoadingDatas() {
  //   let token = localStorage.getItem('id_token');
  //   return this.http.get(emiGlobals.subProductUrl + '?token=' + token).map(res => res.json());
  // }

  // getSubProducts() {
  //   this.getBasicLoadingDatas().subscribe(data => {
  //     this.productList = data;
  //   });
  // }

  // onClickOfProduct(data) {
  //   this.questionType = data.question_type;
  //   this.getQuestionsByProductId(data.id, data.question_type, data.bank_id);
  // }
  // getQuestionsByProductId(productId, questionType, bankId) {
  //   this.httpService.getById(emiGlobals.productQuestionUrl + '/' + productId).subscribe(result => {
  //     this.dataList = result;
  //     let postItems: any = [];
  //     postItems = this.getQuestions(productId, questionType, bankId);
  //     this.widgetHostService.loadReportComponent(this.bank.viewContainerRef, postItems[0]);
  //   });
  // }

}



// WEBPACK FOOTER //
// ./src/app/calculators/home-loan-comparison-calculator/calculator-left-side-menu/calculator-left-side-menu.component.ts